
















































import { Component, Vue } from 'vue-property-decorator';
import AccountCredit from '@/components/account/AccountCredit.vue';
import AccountInvoices from '@/components/account/AccountInvoices.vue';
import AccountLogs from '@/components/account/AccountLogs.vue';
import AccountProfile from '@/components/account/AccountProfile.vue';
import BillingProfile from '@/components/account/BillingProfile.vue';
import AccountProjectBilling from '@/components/account/AccountProjectBilling.vue';
import AccountSubscriptions from '@/components/account/AccountSubscriptions.vue';
import { AccountProfileComponents } from '@/enums/AccountProfileComponents';
import { Action } from 'vuex-class';

@Component({
    components: {
        AccountCredit,
        AccountInvoices,
        AccountLogs,
        AccountProfile,
        BillingProfile,
        AccountProjectBilling,
        AccountSubscriptions,
    },
})
export default class Account extends Vue {

    protected get activeAccount() {
        return this.$store.getters['user/activeAccount'];
    }

    protected get userData() {
        return this.$store.getters['user/userData'];
    }

    protected get billingAddresses() {
        return this.$store.getters['user/billingAddresses'];
    }

    protected get usersName() {
        let names = this.userData.firstName ? this.userData.firstName : '';
        if (this.userData.lastName) {
            names += ' ' + this.userData.lastName;
        }
        return names;

    }

    protected currentActiveComponent = 'AccountSubscriptions';
    @Action('user/getCheckoutList') private getCheckoutList!: (typeName: string) => void;
    @Action('user/getActiveAccount') private getActiveAccount!: () => void;
    @Action('user/getBillingAddresses') private getBillingAddresses!: () => void;
    @Action('user/getInvoices') private getInvoices!: () => void;
    @Action('user/getLoginRecords') private getLoginRecords!: () => void;
    @Action('user/getProjectBillings') private getProjectBillings!: () => void;

    public async mounted() {
        await this.getCheckoutList('subscription');
        await this.getActiveAccount();
        await this.getBillingAddresses();
        await this.getInvoices();
        await this.getLoginRecords();
        await this.getProjectBillings();

        if (this.$route.params.nested === 'profile') {
            this.currentActiveComponent = 'AccountProfile';
        } else if (this.$route.params.nested === 'billing') {
          this.currentActiveComponent = 'BillingProfile';
        }
    }

    protected navigateToComponent(componentName: AccountProfileComponents) {
        this.currentActiveComponent = componentName;
    }

}
